import { Pipe, PipeTransform } from '@angular/core';
import { getBoardingPassMissingReservationIds } from '@/new-transport/_utils/get-boarding-pass-missing-reservation-ids/get-boarding-pass-missing-reservation-ids';

@Pipe({
	name: 'boardingPassMissingReservationIds',
	standalone: true,
	pure: true,
})
export class BoardingPassMissingReservationIdsPipe implements PipeTransform {
	transform(errors: unknown[] | null | undefined): number[] {
		if (!errors?.length) {
			return [];
		}

		return getBoardingPassMissingReservationIds(errors);
	}
}
